import React from 'react';
import { Sparkles, Volume2, BookOpen, Target, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const DailyRecommendation = ({ stats, onAction }) => {
  // Determine the best recommendation based on user stats
  const getRecommendation = () => {
    const { calligraphy_sessions = 0, keyboard_sessions = 0, total_custom_words = 0 } = stats || {};
    const totalSessions = calligraphy_sessions + keyboard_sessions;

    // New user - start with SRS review
    if (totalSessions < 5) {
      return {
        type: 'srs',
        icon: Target,
        color: 'emerald',
        title: 'Révision du jour',
        description: 'Révise les caractères pour ancrer ta mémoire dès le début.',
        action: 'Commencer la révision',
        actionType: 'srs'
      };
    }

    // Intermediate - practice with stories
    if (totalSessions >= 5 && totalSessions < 20) {
      return {
        type: 'stories',
        icon: BookOpen,
        color: 'fuchsia',
        title: 'Lis une micro-histoire',
        description: 'Renforce ta compréhension avec une courte histoire contextuelle.',
        action: 'Générer une histoire',
        actionType: 'story'
      };
    }

    // Regular user - SRS review
    return {
      type: 'srs',
      icon: Target,
      color: 'emerald',
      title: 'Révision du jour',
      description: 'Tu as des caractères à réviser pour maintenir ta progression.',
      action: 'Commencer la révision',
      actionType: 'srs'
    };
  };

  const recommendation = getRecommendation();
  const Icon = recommendation.icon;

  return (
    <div className={`bg-gradient-to-r from-${recommendation.color}-50 to-${recommendation.color}-100/50 rounded-2xl p-5 border border-${recommendation.color}-200/50 mb-6`}>
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 rounded-xl bg-${recommendation.color}-500 flex items-center justify-center flex-shrink-0`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <Sparkles className={`w-4 h-4 text-${recommendation.color}-500`} />
            <span className={`text-xs font-semibold text-${recommendation.color}-600 uppercase tracking-wide`}>
              Suggestion du jour
            </span>
          </div>
          <h3 className={`font-heading text-lg text-${recommendation.color}-800 mb-1`}>
            {recommendation.title}
          </h3>
          <p className={`text-sm text-${recommendation.color}-700 mb-3`}>
            {recommendation.description}
          </p>
          <Button
            onClick={() => onAction(recommendation.actionType, recommendation.params)}
            className={`bg-${recommendation.color}-500 hover:bg-${recommendation.color}-600 text-white rounded-xl text-sm`}
          >
            {recommendation.action}
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DailyRecommendation;
